import React, { useState, useEffect, useCallback } from 'react'
import { Container, Row, Col, Button, Card, CardBody } from 'reactstrap'
import { Breadcrumbs } from '../../AbstractElements'
import { instructorClassColumns } from '../../Data/ClassManagement/ClassListData'
import { getInstructorIdDataforInstrucor } from '../../lib/classview'
import { getDataforInstructorActiveStudent } from '../../lib/classdetailview'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { DataManagementGrid } from '../Common/DataManagementGrid'
import { GlobalCounselorCorner } from './GlobalCounselorCorner'
import { StudentGrid } from './StudentGrid'

const InstructorClassList = () => {
	const [classList, setClassList] = useState([])
	const [studentList, setStudentList] = useState([])
	const [loading, setLoading] = useState(true)
	const [selectedClass, setSelectedClass] = useState(null)
	const [showStudentGrid, setShowStudentGrid] = useState(false)
	const [searchQuery, setSearchQuery] = useState('')
	const { user } = useAuth()

	const instructorId = user?.id

	// Fetch data from API
	const fetchData = useCallback(async () => {
		if (!instructorId) return

		try {
			setLoading(true)
			const [classData, studentData] = await Promise.all([
				getInstructorIdDataforInstrucor(instructorId),
				getDataforInstructorActiveStudent(instructorId)
			])

			setClassList(classData)
			setStudentList(studentData)
		} catch (error) {
			console.error('Error fetching data:', error)
		} finally {
			setLoading(false)
		}
	}, [instructorId])

	// Handle "More..." button click
	const handleMoreClick = (classItem) => {
		setSelectedClass(classItem)
		setShowStudentGrid(true)
	}

	// Handle back to class list
	const handleBackToList = () => {
		setShowStudentGrid(false)
		setSelectedClass(null)
	}

	// Prepare data for datatable with students
	const tableData = classList.map((classItem) => {
		const classStudents = studentList.filter((student) => student.classId === classItem.id)
		return {
			...classItem,
			students: classStudents,
			onMoreClick: () => handleMoreClick(classItem)
		}
	})

	useEffect(() => {
		fetchData()
	}, [fetchData])

	// Show student grid if selected
	if (showStudentGrid && selectedClass) {
		return (
			<>
				<Breadcrumbs parent="Class Management" title="My Classes" mainTitle="My Classes" />
				<Container fluid={true}>
					<Row>
						<Col sm="12">
							<Container className="d-flex justify-content-between align-items-center mb-3">
								<Button color="outline-secondary" onClick={handleBackToList} className="btn-sm">
									<i className="fa fa-arrow-left me-2"></i>
									Back to Classes
								</Button>
							</Container>
							<StudentGrid classId={selectedClass.id} className={selectedClass.class_name} />
						</Col>
					</Row>
				</Container>
			</>
		)
	}

	return (
		<>
			<Container fluid={true}>
				<Row>
					<Col sm="12">
						<DataManagementGrid
							title="My Classes"
							subTitle="View your assigned classes and students"
							breadcrumbTitle="Class Management"
							breadcrumbMainTitle="Class Management"
							columns={instructorClassColumns}
							data={tableData}
							loading={loading}
							searchQuery={searchQuery}
							setSearchQuery={setSearchQuery}
							searchPlaceholder="Search classes..."
							searchFields={['class_name', 'name', 'surname']}
							noDataMessage="No classes assigned"
						/>
					</Col>
				</Row>

				{/* Global Counselor Corner */}
				<Row>
					<Col sm="12">
						<Card>
							<CardBody>
								<GlobalCounselorCorner slug={instructorId} isAdmin={false} />
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Container>
		</>
	)
}

export { InstructorClassList }
